function formatWithDelimiters(
  number,
  precision = 2,
  thousands = ',',
  decimal = '.'
) {
  if (Number.isNaN(number) || number == null) return 0;

  const formattedNum = (number / 100.0).toFixed(precision);
  const parts = formattedNum.split('.');
  const dollarsAmount = parts[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${thousands}`
  );
  const centsAmount = parts[1] ? decimal + parts[1] : '';

  return dollarsAmount + centsAmount;
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @param {Boolean} removeHTML - If True will strip out \u003c\/span\u003e and \u003cspan class=money\u003e
 * @return {String} value - formatted value
 */
// eslint-disable-next-line
export default function formatMoney(cents, format = '${{amount}}', removeHTML) {
  const formatRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formattedCents = cents;
  let value = '';
  if (typeof formattedCents === 'string') {
    formattedCents = formattedCents.replace('.', '');
  }

  if (removeHTML) {
    // eslint-disable-next-line
    format = format
      .replace('\u003cspan class=money\u003e', '')
      .replace('\u003c\\/span\u003e', '')
      .replace('</span>', '');
  }

  switch (format.match(formatRegex)[1]) {
    case 'amount_no_decimals':
      value = formatWithDelimiters(formattedCents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(formattedCents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(formattedCents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(formattedCents, 2);
  }

  return format.replace(formatRegex, value);
}
